<template>
<div>
  <v-container class="reduzed-max-width">
  <slot name="title"></slot>

  <v-row dense align="center">
    <v-col cols="12" md="8">
      <geocoder-autocomplete @change="geoaddress"></geocoder-autocomplete>
    </v-col>
    <v-col cols="12" md="4">
      <v-btn v-if="!showAddressFields" text @click="showAddressFields = !showAddressFields">Adresse manuell eingeben</v-btn>
      <v-btn v-else-if="this.location.lat && this.location.lng"
        @click="next" color="primary" block large>Details eingeben <v-icon light right>$vuetify.icons.next</v-icon></v-btn>
    </v-col>
  </v-row>

    <template v-if="showAddressFields">
      <v-row dense>
        <v-col cols="6" md="4">
          <v-text-field :value="location.street" @input="change('street', $event)" :label="$t('Straße')" filled outlined hide-details="auto"></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
          <v-text-field :value="location.number" @input="change('number', $event)" :label="$t('Haus-Nr.')" filled outlined hide-details="auto"></v-text-field>
        </v-col>
        <v-col cols="6" md="3">
          <v-text-field :value="location.zip" @input="change('zip', $event)" :label="$t('PLZ')" filled outlined hide-details="auto"></v-text-field>
        </v-col>
        <v-col cols="6" md="3">
          <v-text-field :value="location.city" @input="change('city', $event)" :label="$t('Stadt')" filled outlined hide-details="auto"></v-text-field>
        </v-col>
      </v-row>
    </template>
  </v-container>

  <v-container>
    <standard-map :center="mapCenter" :zoom="mapZoom" @load="onMapLoad"></standard-map>
    <div class="text-center mt-6">
      <v-btn @click="next" color="primary" large>Weitere Details eingeben <v-icon light right>$vuetify.icons.next</v-icon></v-btn>
    </div>
  </v-container>
</div>
</template>

<script>
import GeocoderAutocomplete from "../utils/GeocoderAutocomplete";
import StandardMap from "../utils/StandardMap";

let L;

export default {
  name: "InquiryAddress",

  components: {
    StandardMap,
    GeocoderAutocomplete
  },

  props: [
    "mapCenter",
    "mapZoom",
    "location"
  ],

  data() {
    return {
      map: null,
      mapMarker: null,
      standardMap: null,
      showAddressFields: false
    };
  },

  mounted() {
    if (this.location.lat && this.location.lng) {
      this.showAddressFields = true;
    }
  },

  methods: {
    geoaddress(geo) {
      if ("text" in geo) {
        this.autocomplete = geo.text;
      } else {
        this.autocomplete = geo.zip + " " + geo.city;
      }

      if (!this.mapMarker) {
        this.mapMarker = this.standardMap.L.marker([geo.lat, geo.lng]).addTo(this.standardMap.getMap());
      } else {
        this.mapMarker.setLatLng([geo.lat, geo.lng]);
      }

      this.standardMap.getMap().setView([geo.lat, geo.lng], 18);

      this.$emit("update", {
        zip: geo.zip,
        city: geo.city,
        district: geo.district,
        street: geo.street,
        number: geo.number,
        lat: geo.lat,
        lng: geo.lng
      });

      this.showAddressFields = true;
    },

    next() {
      this.$emit("next");
    },

    onMapLoad(standardMap) {
      this.standardMap = standardMap;
    },

    change(k, $event) {
      const e = {...this.location};
      e[k] = $event;
      this.$emit("update", e);
    },
  }
};
</script>
